import React from 'react';
import PropTypes from 'prop-types';
import { Image, LoadingSpinner } from 'reaxl';
import clsx from 'clsx';

/**
 *  The VideoPlaceholder component is a static component that will render in place of an video when the source is not present.
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function VideoPlaceholder(_ref) {
  let {
    image,
    width = 500,
    height = 375,
    className,
    imgClassname,
    loadingClassName,
    overlayColor
  } = _ref;
  const rootClassName = clsx(className, {
    'bg-dark': overlayColor === undefined
  }, 'position-relative');
  const imageClassName = clsx(imgClassname, 'opacity-20');
  const loadingSpinnerClassName = clsx(loadingClassName, 'position-absolute w-100 h-100 display-flex align-items-center justify-content-center margin-top-0 top-0');
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "videoPlaceholder",
    className: rootClassName,
    style: {
      width,
      height,
      backgroundColor: overlayColor
    },
    children: [image && /*#__PURE__*/_jsx(Image, {
      lazyload: false,
      src: image,
      alt: "Video Placeholder",
      className: imageClassName,
      width: width,
      height: height
    }), /*#__PURE__*/_jsx(LoadingSpinner, {
      className: loadingSpinnerClassName
    })]
  });
}
export default VideoPlaceholder;